import React from 'react';
import PropTypes from 'prop-types';

export default function PhonePortraitIcon({ size, color, ...rest }) {
  return (
    <svg width={size} height={size} viewBox="0 0 13 20" {...rest}>
      <path
        fill={color}
        d="M11.375,0 L1.625,0 C0.731249998,0 0,0.713987473 0,1.58663883 L0,1.6263048 C0,1.81141267 0,6.80932499 0,16.6200418 L2.39687496,14.3194154 C2.39687496,7.39109255 2.39687496,3.87404315 2.39687496,3.76826722 C2.39687496,3.45093946 2.68125004,3.13361169 3.00624999,3.13361169 L9.91249998,3.13361169 C10.2375,3.13361169 10.5625,3.45093946 10.5625,3.76826722 L10.5625,14.4780793 C10.5625,14.7954071 10.2375,15.0334029 9.91249998,15.0334029 L3.00624999,15.0334029 C2.68125004,15.0334029 2.39687496,14.7954071 2.39687496,14.4780793 L2.39687496,13.3899976 C2.39687496,13.2313337 2.234375,14.2004175 2.1125,14.3194154 C2.1125,14.3194154 0.568750002,15.8267224 0.406249998,15.9060542 C0.162499995,16.0647181 0,16.302714 0,16.6200418 L0,17.4133612 C0,18.2860125 0.690624999,19 1.584375,19 L11.334375,19 C12.228125,19 13,18.2860125 13,17.4133612 L13,1.58663883 C13,0.713987473 12.26875,0 11.375,0 Z M6.5,18.2463466 C5.80937503,18.2463466 5.28125004,17.7306889 5.28125004,17.0563674 C5.28125004,16.3820459 5.80937503,15.8663883 6.5,15.8663883 C7.19062497,15.8663883 7.71874996,16.3820459 7.71874996,17.0563674 C7.71874996,17.7306889 7.19062497,18.2463466 6.5,18.2463466 Z"
      />
    </svg>
  );
}

PhonePortraitIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

PhonePortraitIcon.defaultProps = {
  size: 15,
  color: '#000',
};
